import { cn } from '@nexo/ui';
import { useId } from 'react';

/**
 * The Nexo mark: an «N» drawn as four connected nodes over a night sky with the landing's aurora
 * on the horizon. Same drawing as public/favicon.svg and apps/desktop/app-icon.svg.
 */
export function LogoMark({ className }: { className?: string }) {
  const id = useId();
  return (
    <svg viewBox="0 0 64 64" aria-hidden className={cn('size-8 shrink-0', className)}>
      <defs>
        <linearGradient id={`${id}bg`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#070b1a" />
          <stop offset="1" stopColor="#0f1838" />
        </linearGradient>
        <radialGradient id={`${id}glow`} cx="0.5" cy="1.12" r="0.8">
          <stop offset="0" stopColor="#ffc061" />
          <stop offset="0.3" stopColor="#ff8d42" stopOpacity="0.7" />
          <stop offset="0.58" stopColor="#3d6bff" stopOpacity="0.5" />
          <stop offset="1" stopColor="#3d6bff" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={`${id}rim`} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#ffd18a" stopOpacity="0" />
          <stop offset="0.5" stopColor="#ffe2b0" />
          <stop offset="1" stopColor="#ffd18a" stopOpacity="0" />
        </linearGradient>
        <clipPath id={`${id}clip`}>
          <rect width="64" height="64" rx="15" />
        </clipPath>
      </defs>
      <g clipPath={`url(#${id}clip)`}>
        <rect width="64" height="64" fill={`url(#${id}bg)`} />
        <rect width="64" height="64" fill={`url(#${id}glow)`} />
        <path d="M-4 62Q32 46 68 62" fill="none" stroke={`url(#${id}rim)`} strokeWidth="1.4" />
      </g>
      <path
        d="M19 44V20L45 44V20"
        fill="none"
        stroke="#fff"
        strokeWidth="4.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="19" cy="44" r="4.4" fill="#fff" />
      <circle cx="19" cy="20" r="4.4" fill="#fff" />
      <circle cx="45" cy="44" r="4.4" fill="#fff" />
      <circle cx="45" cy="20" r="7.5" fill="#ffc061" fillOpacity="0.25" />
      <circle cx="45" cy="20" r="4.6" fill="#ffc861" />
      <rect
        x="0.5"
        y="0.5"
        width="63"
        height="63"
        rx="14.5"
        fill="none"
        stroke="#fff"
        strokeOpacity="0.1"
      />
    </svg>
  );
}

export function Logo({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <LogoMark />
      <span className="font-display text-[19px] font-semibold tracking-tight">nexo</span>
    </span>
  );
}
